// useDateManagement.ts
import { useState, useEffect } from 'react';
import { DateTime } from 'luxon';

/**
 * Custom hook to manage date selection for appointment scheduling
 */
export const useDateManagement = (selectedDoctor: any) => {
    // Initialize with current date - mark it as valid to match the required type
    const [startDate, setStartDate] = useState<DateTime>(DateTime.now());


    // Reset the start date when a new doctor is selected
    useEffect(() => {
        if (selectedDoctor?.first_slot?.date) {
            // Convert the first_slot date to DateTime
              //logger.log("Date Data:", DateTime.fromFormat(firstAvailableTimeData?.date, 'dd-MM-yyyy').toFormat('yyyy-MM-dd'));
            const firstSlotDate = DateTime.fromFormat(selectedDoctor.first_slot.date, 'dd-MM-yyyy').toFormat('yyyy-MM-dd');
            
            // Set the startDate to the beginning of the day of the first available slot
            setStartDate(firstSlotDate ? DateTime.fromISO(firstSlotDate).startOf('day') : DateTime.now().startOf('day'));
        } else {
            // Fallback to current date if no first_slot is available
            setStartDate(DateTime.now().startOf('day'));
        }
    }, [selectedDoctor]);

    return { startDate, setStartDate };
};

export default useDateManagement;